import { IHeatmapConfig } from "@/models/heatmap";
import store from "@/store";
import { GET } from "@/core/http/methods";

declare var require: any;

const toggleHeatmap = (associated_heatmap: string, isToggle: boolean) => {
  const heatmapsConfig = store.getters.GET_HEATMAPS_CONFIG;
  const heatmapConfig: IHeatmapConfig = heatmapsConfig.find((config: IHeatmapConfig) => {
    return config.classification.toLowerCase() === associated_heatmap?.toLowerCase();
  });
  if (heatmapConfig && isHeatmapEnabledForSlide(heatmapConfig)) {
    if (isToggle || !isHeatmapActive(heatmapConfig)) {
      store.dispatch("TOGGLE_HEATMAP", { heatmapConfig });
    }
  }
  if (!heatmapConfig || !isHeatmapEnabledForSlide(heatmapConfig)) {
    store.dispatch("CLEAR_ALL_HEATMAPS");
  }
};

const isHeatmapEnabledForSlide = (heatmap: any) => {
  return store.getters.GET_CURRENT_SLIDE.heatmaps.some((hm: any) => {
    return hm.classification === heatmap?.classification;
  });
};

const isHeatmapActive = (heatmap: any) => {
  return (
    store.state.isVisible &&
    store.state.activeHeatmaps.some(
      (hm: any) => hm.classification === heatmap.classification && hm.isActive
    )
  );
};

const loadHeatmapImg = (src: string) => {
  store.commit("setHeatmapLoader", true);
  const image = new Image();
  image.addEventListener("load", function () {
    store.commit("setHeatmapLoader", false);
  });
  image.src = src;
};

export { toggleHeatmap, isHeatmapEnabledForSlide, isHeatmapActive, loadHeatmapImg };
